module.exports = __webpack_public_path__ + "img/icon-download.1227ca61.svg";